export const parseNumber = (value: string, decimalPlaces = 2): number => {
  if (!value) {
    return 0;
  } else {
    const parsedNumber = parseFloat(value ? removeMoneyMask(value) : value);
    const roundingValue = Math.pow(10, decimalPlaces);
    return Math.round(parsedNumber * roundingValue) / roundingValue;
  }
};

export const removeMoneyMask = (amount: string) =>
  amount.replace(/[$,]/g, "").replace(/\s[A-Z]{3}$/, "");

export const parseMoney = (amount: string) => Number(removeMoneyMask(amount));

export const parseIntegerAmount = (value: string | undefined): string => {
  if (!value) {
    return "";
  }
  return Math.floor(parseFloat(value.replace(/[$,]/g, ""))).toString();
};
